module.exports = __webpack_public_path__ + "static/media/ionic.449e070a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/ionic.png
// module id = 119
// module chunks = 0